import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Input from './Forms/Input';
import SaveButton from './SaveButton';
import ModalFrame from './ModalFrame';

interface EditClientNameProps extends React.ComponentPropsWithoutRef<typeof ModalFrame> {
	current: string;
	label: string;
	buttonLabel: string;
	onClickSet: (val: string) => void;
}

export default function EditValueModal(props: EditClientNameProps) {
	const { current, label, buttonLabel, onClickSet, ...modalFrameProps } = props;

	const [value, setValue] = useState<string>(current);
	const [loading, setLoading] = useState<boolean>(false);

	const saveNewValue = () => {
		setLoading(true);
		onClickSet(value.trim());
	};

	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		setTimeout(() => inputRef.current?.focus(), 500);
	}, []);

	return (
		<ModalFrame {...modalFrameProps}>
			<Container>
				<FormGroup>
					<Input
						forwardRef={inputRef}
						onEnter={saveNewValue}
						value={value}
						onChange={setValue}
						label={label}
					/>
				</FormGroup>
				<SaveButton disabled={value.trim() === '' || loading} onClick={saveNewValue} label={buttonLabel} />
			</Container>
		</ModalFrame>
	);
}

const FormGroup = styled.div`
	padding: 10px;
`;

const Container = styled.div`
	.form-group {
		margin: 0;

		label {
			font-size: 12px;
			margin-bottom: 0;
			margin-left: 10px;
			font-weight: 700;
		}

		.form-control {
			height: unset;
			padding: 0.275rem 0.62rem;
			font-size: 12px;
			line-height: 1;
			margin-bottom: 0.3rem;
		}
	}
`;
